module.exports = __webpack_public_path__ + "static/media/em-95.74223b8f.png";